import axios from 'lib/axios'

export type ActionCodePurpose = 'account_activation' | 'password_recovery'

interface ActionCodeContext {
  status: string
  data: {
    personId: number
    first_name: string
    last_name: string
    document: string
    role: string
    active: boolean
    requires_document: boolean
    requires_birth_date: boolean
  }
}

interface ResendActivationCodeResponse {
  message: string
}

export const verifyActionCode = async (
  email: string,
  code: string,
  purpose: ActionCodePurpose,
): Promise<void> => {
  await axios.post('/auth/action-codes/verify', { email, code, purpose })
}

export const getActionCodeContext = async (
  purpose: ActionCodePurpose,
): Promise<ActionCodeContext> => {
  const response = await axios.get('/auth/action-codes/context', {
    params: { purpose },
  })

  return response.data
}

export const resendActivationCode = async (email: string): Promise<ResendActivationCodeResponse> => {
  const response = await axios.post('/auth/action-codes/resend', { email })

  return response.data
}
